import { jsxs as m, jsx as s } from "react/jsx-runtime";
import { E as v, S as d } from "./icons.types-0722eef5.js";
function p({ title: i, titleId: c, size: l, width: e, height: t, extended: o = !1, ...r }) {
  const n = o ? v : d, a = l ? n[l] : e || n[o ? "s" : "l"], h = l ? n[l] : t || n[o ? "s" : "l"];
  return /* @__PURE__ */ m(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 32 32",
      width: a,
      height: h,
      "aria-labelledby": c,
      ...r,
      children: [
        i ? /* @__PURE__ */ s("title", { id: c, children: i }) : null,
        /* @__PURE__ */ s(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M25.35 16A9.35 9.35 0 0 1 16 25.35 9.35 9.35 0 0 1 6.65 16 9.35 9.35 0 0 1 16 6.65 9.35 9.35 0 0 1 25.35 16Zm2 0c0 6.268-5.082 11.35-11.35 11.35C9.73 27.35 4.65 22.268 4.65 16 4.65 9.73 9.73 4.65 16 4.65c6.268 0 11.35 5.081 11.35 11.35Zm-12.365 5.05v1.616h1.55v-1.558c.767-.117 1.4-.405 1.901-.864.501-.459.764-1.125.788-1.997.024-.73-.195-1.354-.657-1.868-.461-.515-1.136-.908-2.024-1.178-1.049-.336-1.703-.614-1.962-.835-.26-.222-.389-.518-.389-.89 0-.3.144-.567.431-.801.288-.235.673-.352 1.155-.352.461 0 .827.114 1.098.343.27.228.485.516.643.863l1.419-.632a3.225 3.225 0 0 0-.972-1.353 2.86 2.86 0 0 0-1.431-.654V9.332h-1.55v1.558a3.442 3.442 0 0 0-1.623.856c-.48.44-.72 1.041-.72 1.803 0 .63.213 1.195.637 1.695.424.5 1.193.917 2.308 1.251.77.231 1.31.483 1.62.755a1.3 1.3 0 0 1 .467 1.02c0 .453-.169.795-.507 1.024-.337.23-.754.345-1.25.345-.6 0-1.073-.151-1.42-.453-.347-.302-.618-.75-.812-1.344l-1.433.56c.216.788.55 1.39 1.004 1.804.453.415 1.03.696 1.73.843Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
export {
  p as Payment
};
